// import { obterLocalizacao, loadBotao, loadFullPage, postFetch } from "./utilidades";
import { obterLocalizacao } from './utilidades/obterLocalizacao';
import { loadBotao } from './utilidades/loadBotao';
import { loadFullPage } from './utilidades/loadFullPage';
import { postFetch } from './utilidades/postFetch';
import { tooglePassword } from './utilidades/tooglePassword';
import IMask from "imask";
import JustValidate from "just-validate";
import i18next from 'i18next';
import intlTelInput from 'intl-tel-input';
import { flatpickrCustomizado } from './utilidades/flatpickrCustomizado';
import { inicializarInternacionalizacao } from './localizacao/login-esqueci-senha/login-esqueci-senha';
import { addTrack } from "./utilidades/trackEventos";
import { getGeoData } from './utilidades/geoData';
import { obterCandidaturaPendente } from './utilidades/candidaturaPendente';
import { Report } from 'notiflix';

const _templateQuestionario = function (titulo, perguntas) {
    var html = [];

    html.push(`<h2 class="text-primary text-center">${i18next.t('RecuperarSenhaTituloQuestionario')}</h1>`);
    html.push('<p class="text-center"><b>' + titulo + '</b></p>');
    for (var i = 0; i < perguntas.length; i++) {
        html.push('<button type="button" class="btn btn-default w-100 mb-3 btn-resposta">' + perguntas[i] + '</button>');
    }
    return html.join('');
};
const _templateFinalizouQuestionario = function (link) {
    var html = [];
    html.push(`<h1 class="h3 text-primary text-center">${i18next.t('RecuperarSenhaQuestionarioConcluidoTitulo')}</h1>`);

    html.push(`<p class="text-center">${i18next.t('RecuperarSenhaQuestionarioConcluidoTexto')}</p>`);

    html.push('<div class="d-grid gap-2"><a href="' + link + `" class="btn btn-success text-light"><i class="bi bi-pencil-square"></i> ${i18next.t('RecuperarSenhaQuestionarioConcluidoTextoBotao')}</button></div>`);

    return html.join('');
};

const esqueciSenha = function () {

    const $form = document.getElementById('form-esqueci-senha');
    const botaoSolicitar = document.getElementById('btn-esqueci-senha');
    let paisID = '';
    const _call = async () => {
        loadBotao.mostrar(botaoSolicitar);
        const formData = new FormData($form);

        const callbackSucesso = (resultado) => {
            loadBotao.esconder(botaoSolicitar);
            if (resultado.sucesso) {
                const containerPessoa = document.getElementById('container-pessoas');

                if (resultado.pessoas && resultado.pessoas.length > 0) {
                    $form.classList.add("d-none");
                    containerPessoa.classList.remove('d-none');
                    const lista = containerPessoa.querySelector('.list-group');
                    const html = [];

                    html.push('<div class="list-group">');
                    for (var i = 0; i < resultado.pessoas.length; i++) {
                        html.push(`
                            <a href="javascript:void(0)" class="list-group-item pessoa-escolha" data-id="${resultado.pessoas[i].ID}">
                                <div class="nome-pessoa" data-id="${resultado.pessoas[i].ID}">${resultado.pessoas[i].Nome}</div>
                                <div class="clearfix"></div>
                            </a>
                        `)
                    }
                    html.push('</div>');
                    lista.innerHTML = html.join('');

                    lista.querySelectorAll('.pessoa-escolha').forEach(pe => pe.addEventListener('click', async event => {
                        const formData = new FormData($form);
                        formData.append('id', event.target.getAttribute('data-id'));

                        await postFetch(`/${CULTURE_EMPREGARE}/candidato/esqueci-senha`, formData, callbackSucesso, callbackErro, callbackErro);
                    }));

                    document.getElementById('cancelar-varias-pessoas-esqueci-senha').addEventListener('click', () => {
                        $form.classList.remove('d-none');
                        containerPessoa.classList.add('d-none');
                    })

                    return;
                }
                
                paisID = resultado.paisID;
                $form.classList.add("d-none");
                containerPessoa.classList.toggle('d-none', true);

                document.getElementById('TokenUsuario').value = resultado.token;

                $form.querySelector('#emailCpf').value = '';

                // Oculto por nova funcionalidade: agora envia e-mail direto sem exibir tela de escolha
                // const $containerEscolher = document.getElementById('container-escolher-alteracao');
                // $containerEscolher.classList.remove('d-none');
                // document.getElementById('btnAlterarSenhaQuestionario').classList.add('d-none');

                _callAlterarSenhaEmail();
            } else {
                let $rowErro = $form.querySelector('#row-erro');
                $rowErro.classList.remove('d-none');
                $rowErro.querySelector('.retorno-mensagem').innerHTML = resultado.mensagem;
            }
        }
        const callbackErro = (resultado) => {
            loadBotao.esconder(botaoSolicitar);

            let $rowErro = $form.querySelector('#row-erro');
            $rowErro.classList.remove('d-none');
            $rowErro.querySelector('.retorno-mensagem').innerHTML = resultado.mensagem;
        }
        
        const callbackErroConexao = () => {
            loadBotao.esconder(botaoSolicitar);
            let $rowErro = $form.querySelector('#row-erro');
            $rowErro.classList.remove('d-none');
        }
        
        await postFetch(`/${CULTURE_EMPREGARE}/candidato/esqueci-senha`, formData, callbackSucesso, callbackErro, callbackErroConexao);

    };
    const _callAlterarSenhaEmail = async () => {
        loadFullPage.mostrar();

        const token = document.getElementById('TokenUsuario').value;
        const $container = document.getElementById('container-escolher-alteracao');

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            addTrack('Recuperacao Senha', { recuperacaoPor: 'email' });

            $container.innerHTML = `
                <h1 class="h3 text-primary text-center mb-4">${i18next.t('RecuperarSenhaEnvioEmail')}</h1>
                <div class="text-center">
                    <p><b class="text-success">${i18next.t('RecuperarSenhaEnvioEmailInformacoes')}</b></p>
                    <h5><b>${resultado.email}</b></h5>
                    <p>${i18next.t('RecuperarSenhaEnvioEmailVerificarSpam')}</p> 
                    <p class="text-center"><a href="#" id="naoTenhoAcessoEmail" class="btn w-100 btn-outline-primary">${i18next.t('RecuperarSenhoEnvioEmailObterOutroEmail')}</a></p>
                </div>`;

            $container.classList.remove('d-none');

            document.getElementById('container-questionario').classList.add('d-none');

            $container.querySelector('#naoTenhoAcessoEmail').addEventListener('click', function () {
                _callObterCelularSMS();
                return false;
            }, false);


        }
        const callbackErro = () => {
            loadFullPage.esconder();
        }

        let formData = new FormData();
        formData.append('token', token);

        const candidaturaPendente = obterCandidaturaPendente();
        if (candidaturaPendente.vagaID != '0') {
            formData.append('vagaID', candidaturaPendente.vagaID);
            formData.append('redirect', `${candidaturaPendente.url}?confirmar=1`);
        }
        await postFetch(`/${CULTURE_EMPREGARE}/Login/AlterarSenhaViaEmail`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _callResponderQuestionario = async (resposta) => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;
        const tipoPergunta = document.getElementById('TipoPergunta').value;
        const $containerQuestionario = document.getElementById('container-questionario');

        

        let formData = new FormData();
        formData.append('token', token);
        formData.append('tipoPergunta', tipoPergunta);
        formData.append('resposta', resposta);

        const candidaturaPendente = obterCandidaturaPendente();

        if (candidaturaPendente.vagaID != '0') {
            formData.append('vagaID', candidaturaPendente.vagaID);
            formData.append('redirect', `${candidaturaPendente.url}?confirmar=1`);
        }

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            if (!resultado.acertou) {
                $containerQuestionario.innerHTML = `
                    <h2 class="h3 text-primary text-center mb-3">${i18next.t('RecuperarSenhaQuestionarioIncorreto')}</h2>
                    <div class="alert alert-warning text-center">${i18next.t('RecuperarSenhaQuestionarioIncorretoTexto')}
                        <p class="text-center"><a href="#" id="alteracaoPorEmail" class="btn w-100 btn-outline-primary mt-4">${i18next.t('RecuperarSenhaQuestionarioIncorretoOrientacoes')}</a></p>
                    </div>`;

                $containerQuestionario.querySelector('#alteracaoPorEmail').addEventListener('click', function () {
                    _callAlterarSenhaEmail();
                    return false;
                }, false);
                return;
            }
            if (resultado.link !== '') {
                $containerQuestionario.innerHTML = _templateFinalizouQuestionario(resultado.link);
                return;
            }
            $containerQuestionario.innerHTML = _templateQuestionario(resultado.pergunta.titulo, resultado.pergunta.alternativas);
            document.getElementById('TipoPergunta').value = resultado.pergunta.tipo;


            const btnsRespostas = $containerQuestionario.querySelectorAll('.btn-resposta');
            btnsRespostas.forEach((item) => {
                item.addEventListener('click', function (e) {
                    let resposta = this.innerHTML;
                    _callResponderQuestionario(resposta);
                    return false;
                }, false);
            });

        }
        const callbackErro = () => {
            loadFullPage.esconder();
        }

        await postFetch(`/${CULTURE_EMPREGARE}/Login/VerificarResposta`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _callAlterarSenhaQuestionario = async function () {
        loadFullPage.mostrar();

        const token = document.getElementById('TokenUsuario').value;
        const $containerQuestionario = document.getElementById('container-questionario');

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            addTrack('Recuperacao Senha', { recuperacaoPor: 'questionario' });

            document.getElementById('container-escolher-alteracao').classList.add('d-none');

            $containerQuestionario.innerHTML = _templateQuestionario(resultado.pergunta.titulo, resultado.pergunta.alternativas);
            document.getElementById('TipoPergunta').value = resultado.pergunta.tipo;

            const btnsRespostas = $containerQuestionario.querySelectorAll('.btn-resposta');
            btnsRespostas.forEach((item) => {
                item.addEventListener('click', function (e) {
                    let resposta = this.innerHTML;
                    console.log(resposta);
                    _callResponderQuestionario(resposta);
                    return false;
                }, false);
            });

            $containerQuestionario.classList.remove('d-none');


        }
        const callbackErro = () => {
            loadFullPage.esconder();
        }

        let formData = new FormData();
        formData.append('token', token);

        const candidaturaPendente = obterCandidaturaPendente();
        if (candidaturaPendente.vagaID != '0') {
            formData.append('vagaID', candidaturaPendente.vagaID);
            formData.append('redirect', `${candidaturaPendente.url}?confirmar=1`);
        }

        await postFetch(`/${CULTURE_EMPREGARE}/Login/IniciarQuestionario`, formData, callbackSucesso, callbackErro, callbackErro);


    };

    const _hideAllContainers = () => {
        document.getElementById('row-start').classList.add('d-none');
        document.getElementById('row-sucesso').classList.add('d-none');
        document.getElementById('container-escolher-alteracao').classList.add('d-none');
        document.getElementById('container-questionario').classList.add('d-none');
        document.getElementById('container-pessoas').classList.add('d-none');
        document.getElementById('container-sms-escolha').classList.add('d-none');
        document.getElementById('container-sms').classList.add('d-none');
        document.getElementById('container-alterar-email').classList.add('d-none');
        const recAcessoIds = [
            'container-recuperar-acesso-pergunta',
            'container-recuperar-acesso-novo-contato',
            'container-recuperar-acesso-sms-novo',
            'container-recuperar-acesso-nova-senha',
            'container-recuperar-acesso-indisponivel-pais'
        ];
        recAcessoIds.forEach(id => {
            const el = document.getElementById(id);
            if (el) el.classList.add('d-none');
        });
    };

    const _callObterCelularSMS = async () => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();
            if (resultado.sucesso) {
                _hideAllContainers();
                _montarContainerEscolhaSMS(resultado.celularFinal);
            } else {
                window.location.href = `/${CULTURE_EMPREGARE}/suporte/novo`;
            }
        };

        const callbackErro = () => {
            loadFullPage.esconder();
            window.location.href = `/${CULTURE_EMPREGARE}/suporte/novo`;
        };

        let formData = new FormData();
        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/obter-celular-sms/${encodeURIComponent(token)}`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _montarContainerEscolhaSMS = (celularFinal) => {
        const $container = document.getElementById('container-sms-escolha');

        document.getElementById('sms-escolha-titulo').textContent = i18next.t('SMSEscolhaTitulo');
        document.getElementById('sms-escolha-subtitulo').innerHTML = i18next.t('SMSEscolhaSubtitulo', { celularFinal: celularFinal });
        document.getElementById('btn-enviar-sms-texto').textContent = i18next.t('SMSEscolhaBotaoEnviar');

        document.getElementById('btn-enviar-sms').addEventListener('click', function () {
            _callEnviarCelularSMS();
        });

        // Botao "Recuperar acesso" e removido do DOM pelo Razor quando o kill-switch
        // RecuperarAcessoQuizEnabled=false. Protegemos com guards para nao quebrar o fluxo do SMS.
        const $btnRecuperarTexto = document.getElementById('btn-recuperar-acesso-texto');
        if ($btnRecuperarTexto)
            $btnRecuperarTexto.textContent = i18next.t('RecuperarAcessoBotao');

        const $btnRecuperar = document.getElementById('btn-recuperar-acesso');
        if ($btnRecuperar) {
            $btnRecuperar.addEventListener('click', function () {
                _callIniciarRecuperarAcesso();
            });
        }

        $container.classList.remove('d-none');
    };

    // ===========================================================
    // Jornada de Recuperação de Acesso (sem e-mail e sem celular)
    // ===========================================================
    let _recuperarAcessoState = {
        tipoPerguntaAtual: null,
        novoEmail: '',
        novoCelular: '',
        novoCelularPaisCode: '+55',
        itiPergunta: null,
        itiNovoCelular: null,
        fpDataNascimento: null
    };

    const _itiOpcoesPadrao = {
        initialCountry: "br",
        preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
        dropdownContainer: document.body,
        formatOnDisplay: false,
        autoPlaceholder: "aggressive",
        utilsScript: '/assetsV2/lib/intl-tel-util/utils.js'
    };

    const _destruirInstanciasPergunta = () => {
        if (_recuperarAcessoState.itiPergunta) {
            try { _recuperarAcessoState.itiPergunta.destroy(); } catch (e) { }
            _recuperarAcessoState.itiPergunta = null;
        }
        if (_recuperarAcessoState.fpDataNascimento) {
            try { _recuperarAcessoState.fpDataNascimento.destroy(); } catch (e) { }
            _recuperarAcessoState.fpDataNascimento = null;
        }
    };

    const _hideContainersRecuperarAcesso = () => {
        document.getElementById('container-recuperar-acesso-pergunta').classList.add('d-none');
        document.getElementById('container-recuperar-acesso-novo-contato').classList.add('d-none');
        document.getElementById('container-recuperar-acesso-sms-novo').classList.add('d-none');
        document.getElementById('container-recuperar-acesso-nova-senha').classList.add('d-none');
        document.getElementById('container-recuperar-acesso-indisponivel-pais').classList.add('d-none');
    };

    const _aplicarMascaraTelefone = (iti, $input) => {
        if (!iti || !$input) return;
        const brasilDialCode = '55';
        let mask = null;

        const aplicar = () => {
            if (mask) {
                mask.destroy();
                mask = null;
            }
            const dial = iti.getSelectedCountryData().dialCode;
            if (dial === brasilDialCode) {
                mask = IMask($input, {
                    mask: [
                        { mask: '(00) 0000-0000' },
                        { mask: '(00) 00000-0000' }
                    ]
                });
            }
        };

        if (iti.promise && typeof iti.promise.then === 'function') {
            iti.promise.then(aplicar);
        } else {
            aplicar();
        }
        $input.addEventListener('countrychange', aplicar);
    };

    const _renderizarIndisponivelPais = (resultado) => {
        _hideAllContainers();
        _hideContainersRecuperarAcesso();
        const $container = document.getElementById('container-recuperar-acesso-indisponivel-pais');
        document.getElementById('recuperar-acesso-indisponivel-pais-titulo').textContent =
            (resultado && resultado.titulo) || i18next.t('RecuperarAcessoIndisponivelPaisTitulo');
        document.getElementById('recuperar-acesso-indisponivel-pais-texto').textContent =
            (resultado && resultado.mensagem) || i18next.t('RecuperarAcessoIndisponivelPaisTexto');
        document.getElementById('btn-recuperar-acesso-indisponivel-pais-suporte-texto').textContent =
            (resultado && resultado.botaoSuporte) || i18next.t('RecuperarAcessoIndisponivelPaisBotaoSuporte');
        $container.classList.remove('d-none');
    };

    const _callIniciarRecuperarAcesso = async () => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();
            if (resultado.sucesso) {
                _hideAllContainers();
                _hideContainersRecuperarAcesso();
                _renderizarPerguntaRecuperarAcesso(resultado.pergunta);
            } else if (resultado && resultado.codigo === 'INDISPONIVEL_PAIS') {
                _renderizarIndisponivelPais(resultado);
            } else {
                Report.failure(i18next.t('RecuperarAcessoErroTitulo'), resultado.mensagem || i18next.t('RecuperarAcessoErroGenerico'), 'Ok', null);
            }
        };
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
            if (resultado && resultado.codigo === 'INDISPONIVEL_PAIS') {
                _renderizarIndisponivelPais(resultado);
                return;
            }
            Report.failure(i18next.t('RecuperarAcessoErroTitulo'), (resultado && resultado.mensagem) || i18next.t('RecuperarAcessoErroGenerico'), 'Ok', null);
        };

        let formData = new FormData();
        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/recuperar-acesso/iniciar/${encodeURIComponent(token)}`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _renderizarPerguntaRecuperarAcesso = (pergunta) => {
        if (!pergunta || pergunta.tipo === 'Finalizou') {
            _renderizarNovoContatoRecuperarAcesso();
            return;
        }

        _destruirInstanciasPergunta();
        _recuperarAcessoState.tipoPerguntaAtual = pergunta.tipo;

        const $container = document.getElementById('container-recuperar-acesso-pergunta');
        const $titulo = document.getElementById('recuperar-acesso-titulo');
        const $subtitulo = document.getElementById('recuperar-acesso-subtitulo');
        const $textoLivre = document.getElementById('recuperar-acesso-texto-livre');
        const $alternativas = document.getElementById('recuperar-acesso-alternativas');
        const $erro = document.getElementById('recuperar-acesso-erro');
        const $btn = document.getElementById('btn-recuperar-acesso-responder');

        $titulo.textContent = pergunta.titulo || i18next.t(`RecuperarAcessoPergunta${pergunta.tipo}`);
        const chaveSubtitulo = `RecuperarAcessoPergunta${pergunta.tipo}Subtitulo`;
        const subtitulo = i18next.exists(chaveSubtitulo) ? i18next.t(chaveSubtitulo) : '';
        $subtitulo.textContent = subtitulo;
        $subtitulo.classList.toggle('d-none', !subtitulo);
        $erro.classList.add('d-none');
        $btn.textContent = i18next.t('RecuperarAcessoResponder');

        // recria o input de resposta para evitar listeners/instâncias antigos
        const $respostaAntiga = document.getElementById('recuperar-acesso-resposta');
        const $resposta = $respostaAntiga.cloneNode(false);
        $resposta.id = 'recuperar-acesso-resposta';
        $resposta.value = '';
        $resposta.type = 'text';
        $respostaAntiga.parentNode.replaceChild($resposta, $respostaAntiga);

        const ehMultipla = Array.isArray(pergunta.alternativas) && pergunta.alternativas.length > 0;
        if (ehMultipla) {
            $textoLivre.classList.add('d-none');
            $alternativas.classList.remove('d-none');
            const html = ['<div class="list-group">'];
            pergunta.alternativas.forEach((alt, idx) => {
                html.push(`
                    <label class="list-group-item">
                        <input class="form-check-input me-2" type="radio" name="recuperar-acesso-alt" value="${_htmlEscape(alt)}" />
                        ${_htmlEscape(alt)}
                    </label>
                `);
            });
            html.push('</div>');
            $alternativas.innerHTML = html.join('');
        } else {
            $alternativas.classList.add('d-none');
            $alternativas.innerHTML = '';
            $textoLivre.classList.remove('d-none');
            $resposta.placeholder = '';

            if (pergunta.tipo === 'Cpf') {
                $resposta.placeholder = '000.000.000-00';
                IMask($resposta, { mask: '000.000.000-00' });
            } else if (pergunta.tipo === 'DataNascimento') {
                $resposta.placeholder = 'dd/mm/aaaa';
                _recuperarAcessoState.fpDataNascimento = flatpickrCustomizado($resposta, {
                    maxDate: 'today',
                    dateFormat: 'Y-m-d',
                    altFormat: 'd/m/Y',
                    allowInput: true
                }, (CULTURE_EMPREGARE || 'pt-br'));
            } else if (pergunta.tipo === 'TelefoneAntigo') {
                $resposta.type = 'tel';
                $resposta.setAttribute('inputmode', 'tel');
                _recuperarAcessoState.itiPergunta = intlTelInput($resposta, _itiOpcoesPadrao);
                _aplicarMascaraTelefone(_recuperarAcessoState.itiPergunta, $resposta);
            } else if (pergunta.tipo === 'EmailAntigo') {
                $resposta.type = 'email';
                $resposta.placeholder = 'exemplo@dominio.com';
            } else if (pergunta.tipo === 'Nome') {
                $resposta.placeholder = i18next.t('RecuperarAcessoPerguntaNomePlaceholder');
            }

            setTimeout(() => $resposta.focus(), 100);
        }

        $btn.onclick = _callResponderRecuperarAcesso;
        $container.classList.remove('d-none');
    };

    const _htmlEscape = (str) => {
        return String(str || '').replace(/[&<>"']/g, (c) => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    };

    const _callResponderRecuperarAcesso = async () => {
        const $alt = document.getElementById('recuperar-acesso-alternativas');
        const $resposta = document.getElementById('recuperar-acesso-resposta');
        const $erro = document.getElementById('recuperar-acesso-erro');
        const $btn = document.getElementById('btn-recuperar-acesso-responder');
        const tipo = _recuperarAcessoState.tipoPerguntaAtual;

        let resposta = '';
        if (!$alt.classList.contains('d-none')) {
            const selected = $alt.querySelector('input[name="recuperar-acesso-alt"]:checked');
            if (!selected) {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-acesso').textContent = i18next.t('RecuperarAcessoSelecioneOpcao');
                return;
            }
            resposta = selected.value;
        } else if (tipo === 'DataNascimento' && _recuperarAcessoState.fpDataNascimento) {
            const dates = _recuperarAcessoState.fpDataNascimento.selectedDates;
            if (!dates || dates.length === 0) {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-acesso').textContent = i18next.t('RecuperarAcessoPreencha');
                return;
            }
            const d = dates[0];
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            resposta = `${dd}/${mm}/${yyyy}`;
        } else if (tipo === 'TelefoneAntigo' && _recuperarAcessoState.itiPergunta) {
            const iti = _recuperarAcessoState.itiPergunta;
            const numero = iti.getNumber();
            if (!numero) {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-acesso').textContent = i18next.t('RecuperarAcessoPreencha');
                return;
            }
            if (typeof iti.isValidNumber === 'function' && !iti.isValidNumber()) {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-acesso').textContent = i18next.t('RecuperarAcessoCelularInvalido');
                return;
            }
            resposta = numero;
        } else {
            resposta = ($resposta.value || '').trim();
            if (!resposta) {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-acesso').textContent = i18next.t('RecuperarAcessoPreencha');
                return;
            }
        }

        $erro.classList.add('d-none');
        loadBotao.mostrar($btn);

        const token = document.getElementById('TokenUsuario').value;
        const body = JSON.stringify({
            Token: token,
            TipoPergunta: _recuperarAcessoState.tipoPerguntaAtual,
            Resposta: resposta
        });

        const callbackSucesso = (resultado) => {
            loadBotao.esconder($btn);
            if (resultado.sucesso) {
                if (resultado.finalizou || (resultado.pergunta && resultado.pergunta.tipo === 'Finalizou')) {
                    _renderizarNovoContatoRecuperarAcesso();
                } else {
                    _hideContainersRecuperarAcesso();
                    _renderizarPerguntaRecuperarAcesso(resultado.pergunta);
                }
            } else {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-acesso').textContent = resultado.mensagem;
            }
        };
        const callbackErro = (resultado) => {
            loadBotao.esconder($btn);
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-acesso').textContent = (resultado && resultado.mensagem) || i18next.t('RecuperarAcessoErroGenerico');
        };

        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/recuperar-acesso/responder`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    };

    const _renderizarNovoContatoRecuperarAcesso = () => {
        _destruirInstanciasPergunta();
        _hideAllContainers();
        _hideContainersRecuperarAcesso();

        const $container = document.getElementById('container-recuperar-acesso-novo-contato');
        document.getElementById('recuperar-acesso-novo-contato-titulo').textContent = i18next.t('RecuperarAcessoNovoEmailTitulo');
        document.getElementById('recuperar-acesso-novo-contato-subtitulo').textContent = i18next.t('RecuperarAcessoNovoEmailSubtitulo');
        document.getElementById('label-novo-email-acesso').textContent = i18next.t('RecuperarAcessoNovoEmailLabel');
        document.getElementById('label-confirmar-novo-email-acesso').textContent = i18next.t('RecuperarAcessoConfirmarEmailLabel');
        document.getElementById('label-novo-celular-acesso').textContent = i18next.t('RecuperarAcessoNovoCelularLabel');
        document.getElementById('btn-recuperar-acesso-continuar-contato').textContent = i18next.t('RecuperarAcessoContinuar');

        if (_recuperarAcessoState.itiNovoCelular) {
            try { _recuperarAcessoState.itiNovoCelular.destroy(); } catch (e) { }
            _recuperarAcessoState.itiNovoCelular = null;
        }
        const $novoCelular = document.getElementById('novo-celular-acesso');
        $novoCelular.setAttribute('inputmode', 'tel');
        _recuperarAcessoState.itiNovoCelular = intlTelInput($novoCelular, _itiOpcoesPadrao);
        _aplicarMascaraTelefone(_recuperarAcessoState.itiNovoCelular, $novoCelular);

        document.getElementById('btn-recuperar-acesso-continuar-contato').onclick = _callValidarNovoContato;
        $container.classList.remove('d-none');
    };

    const _callValidarNovoContato = async () => {
        const $erro = document.getElementById('recuperar-acesso-novo-contato-erro');
        const $btn = document.getElementById('btn-recuperar-acesso-continuar-contato');
        const novoEmail = (document.getElementById('novo-email-acesso').value || '').trim();
        const confirmarEmail = (document.getElementById('confirmar-novo-email-acesso').value || '').trim();

        let novoCelular = '';
        let paisCode = '+55';
        if (_recuperarAcessoState.itiNovoCelular) {
            const iti = _recuperarAcessoState.itiNovoCelular;
            novoCelular = (document.getElementById('novo-celular-acesso').value || '').trim();
            const dial = iti.getSelectedCountryData().dialCode;
            if (dial) paisCode = `+${dial}`;
            if (novoCelular && typeof iti.isValidNumber === 'function' && !iti.isValidNumber()) {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-novo-contato').textContent = i18next.t('RecuperarAcessoCelularInvalido');
                return;
            }
        } else {
            novoCelular = (document.getElementById('novo-celular-acesso').value || '').trim();
        }

        $erro.classList.add('d-none');

        if (!novoEmail || !confirmarEmail || !novoCelular) {
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-novo-contato').textContent = i18next.t('RecuperarAcessoPreencha');
            return;
        }
        if (novoEmail !== confirmarEmail) {
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-novo-contato').textContent = i18next.t('RecuperarAcessoEmailDivergente');
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(novoEmail)) {
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-novo-contato').textContent = i18next.t('RecuperarAcessoEmailInvalido');
            return;
        }

        _recuperarAcessoState.novoEmail = novoEmail;
        _recuperarAcessoState.novoCelular = novoCelular;
        _recuperarAcessoState.novoCelularPaisCode = paisCode;

        loadBotao.mostrar($btn);
        const token = document.getElementById('TokenUsuario').value;
        const body = JSON.stringify({
            Token: token,
            NovoEmail: novoEmail,
            NovoCelular: novoCelular,
            NovoCelularPaisCode: paisCode
        });

        const callbackSucesso = (resultado) => {
            loadBotao.esconder($btn);
            if (resultado.sucesso) {
                _callEnviarSMSNovoCelular();
            } else {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-novo-contato').textContent = resultado.mensagem;
            }
        };
        const callbackErro = (resultado) => {
            loadBotao.esconder($btn);
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-novo-contato').textContent = (resultado && resultado.mensagem) || i18next.t('RecuperarAcessoErroGenerico');
        };

        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/recuperar-acesso/validar-novo-contato`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    };

    const _callEnviarSMSNovoCelular = async () => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;
        const body = JSON.stringify({
            Token: token,
            NovoCelular: _recuperarAcessoState.novoCelular,
            NovoCelularPaisCode: _recuperarAcessoState.novoCelularPaisCode
        });

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();
            if (resultado.sucesso) {
                _montarContainerSMSNovoCelular(resultado.celularFinal);
            } else {
                const $erro = document.getElementById('recuperar-acesso-novo-contato-erro');
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-novo-contato').textContent = resultado.mensagem;
            }
        };
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
            Report.failure(i18next.t('RecuperarAcessoErroTitulo'), (resultado && resultado.mensagem) || i18next.t('RecuperarAcessoErroGenerico'), 'Ok', null);
        };

        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/recuperar-acesso/enviar-sms-novo-celular`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    };

    const _montarContainerSMSNovoCelular = (celularFinal) => {
        _hideAllContainers();
        _hideContainersRecuperarAcesso();

        const $container = document.getElementById('container-recuperar-acesso-sms-novo');
        document.getElementById('recuperar-acesso-sms-novo-titulo').textContent = i18next.t('SMSVerificacaoTitulo');
        document.getElementById('recuperar-acesso-sms-novo-subtitulo').innerHTML = i18next.t('SMSVerificacaoSubtitulo', { celularFinal: celularFinal });
        document.getElementById('recuperar-acesso-sms-expiracao').innerHTML = `<small>${i18next.t('SMSCodigoExpiracao')}</small>`;

        _criarInputsCodigoRecuperarAcesso();

        $container.classList.remove('d-none');
    };

    const _criarInputsCodigoRecuperarAcesso = () => {
        const $container = document.getElementById('recuperar-acesso-sms-codigo-inputs');
        $container.innerHTML = '';

        for (let i = 0; i < 6; i++) {
            const input = document.createElement('input');
            input.type = 'tel';
            input.maxLength = 1;
            input.inputMode = 'numeric';
            input.pattern = '[0-9]';
            input.className = 'sms-input';
            input.setAttribute('data-index', i);
            input.autocomplete = 'one-time-code';

            input.addEventListener('input', function () {
                const val = this.value.replace(/[^0-9]/g, '');
                this.value = val;
                if (val && i < 5) {
                    $container.children[i + 1].focus();
                }
                _verificarCodigoCompletoRecuperarAcesso();
            });

            input.addEventListener('keydown', function (e) {
                if (e.key === 'Backspace' && !this.value && i > 0) {
                    $container.children[i - 1].focus();
                }
            });

            input.addEventListener('paste', function (e) {
                e.preventDefault();
                const pastedData = (e.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '');
                if (pastedData.length >= 6) {
                    for (let j = 0; j < 6; j++) {
                        $container.children[j].value = pastedData[j] || '';
                    }
                    $container.children[5].focus();
                    _verificarCodigoCompletoRecuperarAcesso();
                }
            });

            $container.appendChild(input);
        }

        $container.children[0].focus();
    };

    const _verificarCodigoCompletoRecuperarAcesso = () => {
        const $container = document.getElementById('recuperar-acesso-sms-codigo-inputs');
        let codigo = '';
        for (let i = 0; i < 6; i++) {
            codigo += $container.children[i].value;
        }
        if (codigo.length === 6) {
            _callConfirmarSMSNovoCelular(codigo);
        }
    };

    const _callConfirmarSMSNovoCelular = async (codigo) => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;
        const body = JSON.stringify({
            Token: token,
            Codigo: codigo,
            NovoCelular: _recuperarAcessoState.novoCelular,
            NovoCelularPaisCode: _recuperarAcessoState.novoCelularPaisCode
        });

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();
            if (resultado.sucesso) {
                _renderizarNovaSenhaRecuperarAcesso();
            } else {
                const $erro = document.getElementById('recuperar-acesso-sms-erro');
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-sms-acesso').textContent = resultado.mensagem;
                const $inputs = document.getElementById('recuperar-acesso-sms-codigo-inputs');
                for (let i = 0; i < 6; i++) $inputs.children[i].value = '';
                $inputs.children[0].focus();
            }
        };
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
            const $erro = document.getElementById('recuperar-acesso-sms-erro');
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-sms-acesso').textContent = (resultado && resultado.mensagem) || i18next.t('SMSCodigoInvalido');
        };

        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/recuperar-acesso/confirmar-sms-novo-celular`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    };

    const _renderizarNovaSenhaRecuperarAcesso = () => {
        _hideAllContainers();
        _hideContainersRecuperarAcesso();

        const $container = document.getElementById('container-recuperar-acesso-nova-senha');
        document.getElementById('recuperar-acesso-nova-senha-titulo').textContent = i18next.t('RecuperarAcessoNovaSenhaTitulo');
        document.getElementById('recuperar-acesso-nova-senha-subtitulo').textContent = i18next.t('RecuperarAcessoNovaSenhaSubtitulo');
        document.getElementById('label-nova-senha-acesso').textContent = i18next.t('RecuperarAcessoNovaSenhaLabel');
        document.getElementById('label-confirmar-nova-senha-acesso').textContent = i18next.t('RecuperarAcessoConfirmarNovaSenhaLabel');
        document.getElementById('btn-recuperar-acesso-concluir').textContent = i18next.t('RecuperarAcessoConcluir');
        document.getElementById('btn-recuperar-acesso-concluir').onclick = _callFinalizarRecuperarAcesso;

        if (!_recuperarAcessoState.togglePasswordInicializado) {
            tooglePassword(document.getElementById('nova-senha-acesso'), document.getElementById('novaSenhaAcessoIcon'));
            tooglePassword(document.getElementById('confirmar-nova-senha-acesso'), document.getElementById('confirmarNovaSenhaAcessoIcon'));
            _recuperarAcessoState.togglePasswordInicializado = true;
        }

        $container.classList.remove('d-none');
    };

    const _callFinalizarRecuperarAcesso = async () => {
        const $erro = document.getElementById('recuperar-acesso-nova-senha-erro');
        const $btn = document.getElementById('btn-recuperar-acesso-concluir');
        const novaSenha = document.getElementById('nova-senha-acesso').value || '';
        const confirmar = document.getElementById('confirmar-nova-senha-acesso').value || '';

        $erro.classList.add('d-none');

        if (!novaSenha || novaSenha.length < 6) {
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-nova-senha').textContent = i18next.t('RecuperarAcessoSenhaMinima');
            return;
        }
        if (novaSenha !== confirmar) {
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-nova-senha').textContent = i18next.t('RecuperarAcessoSenhaDivergente');
            return;
        }

        loadBotao.mostrar($btn);
        const token = document.getElementById('TokenUsuario').value;
        const body = JSON.stringify({
            Token: token,
            NovoEmail: _recuperarAcessoState.novoEmail,
            NovoCelular: _recuperarAcessoState.novoCelular,
            NovoCelularPaisCode: _recuperarAcessoState.novoCelularPaisCode,
            NovaSenha: novaSenha
        });

        const callbackSucesso = (resultado) => {
            loadBotao.esconder($btn);
            if (resultado.sucesso) {
                addTrack('Recuperacao Senha', { recuperacaoPor: 'quiz-autoatendimento' });
                window.location.href = `/${CULTURE_EMPREGARE}/Login/AutenticarComToken?token=${encodeURIComponent(resultado.tokenAutenticacao)}&url=${encodeURIComponent(resultado.redirectUrl)}`;
            } else {
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-nova-senha').textContent = resultado.mensagem;
            }
        };
        const callbackErro = (resultado) => {
            loadBotao.esconder($btn);
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-nova-senha').textContent = (resultado && resultado.mensagem) || i18next.t('RecuperarAcessoErroGenerico');
        };

        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/recuperar-acesso/finalizar`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    };

    const _callEnviarCelularSMS = async () => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();
            if (resultado.sucesso) {
                addTrack('Recuperacao Senha', { recuperacaoPor: resultado.canal === 'whatsapp' ? 'whatsapp' : 'sms' });
                _hideAllContainers();
                _montarContainerSMS(resultado.celularFinal, resultado.canal);
            } else if (resultado.limiteTentativas) {
                Report.failure(i18next.t('SMSLimiteTentativas'), '', 'Ok', () => {
                    window.location.href = `/${CULTURE_EMPREGARE}/suporte/novo`;
                });
            } else {
                Report.failure(i18next.t('SMSErroEnvioTitulo'), resultado.mensagem, 'Ok', null);
            }
        };

        const callbackErro = (resultado) => {
            loadFullPage.esconder();
            Report.failure(i18next.t('SMSErroEnvioTitulo'), resultado.mensagem || i18next.t('SMSErroEnvio'), 'Ok', null);
        };

        let formData = new FormData();
        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/verificar-celular-sms/${encodeURIComponent(token)}`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    let _cooldownTimer = null;

    const _traduzirComFallback = (chave, opcoes, fallback) => {
        try {
            const traducao = i18next.t(chave, opcoes);
            if (traducao && traducao !== chave) return traducao;
        } catch (e) {
            console.error('Falha ao traduzir chave i18n', chave, e);
        }
        return fallback;
    };

    const _montarContainerSMS = (celularFinal, canal) => {
        const $container = document.getElementById('container-sms');

        // O canal efetivo vem do backend: o WhatsApp e a primeira tentativa e o SMS e o fallback.
        const ehWhatsApp = canal === 'whatsapp';

        document.getElementById('sms-titulo').textContent = i18next.t(ehWhatsApp ? 'WhatsAppVerificacaoTitulo' : 'SMSVerificacaoTitulo');
        document.getElementById('sms-subtitulo').innerHTML = i18next.t(ehWhatsApp ? 'WhatsAppVerificacaoSubtitulo' : 'SMSVerificacaoSubtitulo', { celularFinal: celularFinal });
        document.getElementById('sms-expiracao').innerHTML = `<small>${i18next.t('SMSCodigoExpiracao')}</small>`;

        const $reenviar = document.getElementById('sms-reenviar');
        const textoOriginal = $reenviar.textContent;
        $reenviar.textContent = _traduzirComFallback('SMSReenviar', null, textoOriginal || 'Reenviar código');

        _criarInputsCodigo();

        $reenviar.onclick = function () {
            if (!this.classList.contains('disabled')) {
                _callEnviarCelularSMS();
            }
        };

        try {
            _iniciarCooldownReenvio();
        } catch (e) {
            console.error('Falha ao iniciar cooldown de reenvio SMS', e);
        }

        $container.classList.remove('d-none');
    };

    const _iniciarCooldownReenvio = () => {
        if (_cooldownTimer) clearInterval(_cooldownTimer);

        const $reenviar = document.getElementById('sms-reenviar');
        let segundos = 30;

        $reenviar.classList.add('disabled');
        $reenviar.style.pointerEvents = 'none';
        $reenviar.style.opacity = '0.5';
        $reenviar.textContent = _traduzirComFallback('SMSReenviarContador', { segundos: segundos }, `Reenviar código (${segundos}s)`);

        _cooldownTimer = setInterval(() => {
            segundos--;
            if (segundos <= 0) {
                clearInterval(_cooldownTimer);
                _cooldownTimer = null;
                $reenviar.classList.remove('disabled');
                $reenviar.style.pointerEvents = '';
                $reenviar.style.opacity = '';
                $reenviar.textContent = _traduzirComFallback('SMSReenviar', null, 'Reenviar código');
            } else {
                $reenviar.textContent = _traduzirComFallback('SMSReenviarContador', { segundos: segundos }, `Reenviar código (${segundos}s)`);
            }
        }, 1000);
    };

    const _criarInputsCodigo = () => {
        const $container = document.getElementById('sms-codigo-inputs');
        $container.innerHTML = '';

        for (let i = 0; i < 6; i++) {
            const input = document.createElement('input');
            input.type = 'tel';
            input.maxLength = 1;
            input.inputMode = 'numeric';
            input.pattern = '[0-9]';
            input.className = 'sms-input';
            input.setAttribute('data-index', i);
            input.autocomplete = 'one-time-code';

            input.addEventListener('input', function () {
                const val = this.value.replace(/[^0-9]/g, '');
                this.value = val;
                if (val && i < 5) {
                    $container.children[i + 1].focus();
                }
                _verificarCodigoCompleto();
            });

            input.addEventListener('keydown', function (e) {
                if (e.key === 'Backspace' && !this.value && i > 0) {
                    $container.children[i - 1].focus();
                }
            });

            input.addEventListener('paste', function (e) {
                e.preventDefault();
                const pastedData = (e.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '');
                if (pastedData.length >= 6) {
                    for (let j = 0; j < 6; j++) {
                        $container.children[j].value = pastedData[j] || '';
                    }
                    $container.children[5].focus();
                    _verificarCodigoCompleto();
                }
            });

            $container.appendChild(input);
        }

        $container.children[0].focus();
    };

    const _verificarCodigoCompleto = () => {
        const $container = document.getElementById('sms-codigo-inputs');
        let codigo = '';
        for (let i = 0; i < 6; i++) {
            codigo += $container.children[i].value;
        }
        if (codigo.length === 6) {
            _callValidarCodigoSMS(codigo);
        }
    };

    const _callValidarCodigoSMS = async (codigo) => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;

        const callbackSucesso = (resultado) => {
            if (resultado.sucesso) {
                // Auto-login via AutenticarComToken
                window.location.href = `/${CULTURE_EMPREGARE}/Login/AutenticarComToken?token=${encodeURIComponent(resultado.tokenAutenticacao)}&url=${encodeURIComponent(resultado.novaSenhaUrl)}`;
            } else {
                loadFullPage.esconder();
                const $erro = document.getElementById('sms-erro');
                $erro.classList.remove('d-none');
                $erro.querySelector('.retorno-mensagem-sms').textContent = resultado.mensagem;
                const $inputs = document.getElementById('sms-codigo-inputs');
                for (let i = 0; i < 6; i++) {
                    $inputs.children[i].value = '';
                }
                $inputs.children[0].focus();
            }
        };

        const callbackErro = (resultado) => {
            loadFullPage.esconder();
            const $erro = document.getElementById('sms-erro');
            $erro.classList.remove('d-none');
            $erro.querySelector('.retorno-mensagem-sms').textContent = resultado.mensagem || i18next.t('SMSCodigoInvalido');
            const $inputs = document.getElementById('sms-codigo-inputs');
            for (let i = 0; i < 6; i++) {
                $inputs.children[i].value = '';
            }
            $inputs.children[0].focus();
        };

        const body = JSON.stringify({ Token: token, Codigo: codigo });
        await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/validar-codigo-sms`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    };

    // Oculto por nova funcionalidade: agora após validar SMS, faz auto-login e redireciona para atualização de dados de contato
    // const _montarFormularioEmail = () => {
    //     const $container = document.getElementById('container-alterar-email');
    //     document.getElementById('alterar-email-titulo').textContent = i18next.t('AlterarEmailTitulo');
    //     document.getElementById('alterar-email-subtitulo').textContent = i18next.t('AlterarEmailSubtitulo');
    //     document.getElementById('label-novo-email').textContent = i18next.t('AlterarEmailNovoLabel');
    //     document.getElementById('label-confirmar-email').textContent = i18next.t('AlterarEmailConfirmarLabel');
    //     document.getElementById('btn-alterar-email').textContent = i18next.t('AlterarEmailBotao');
    //     const btnAlterarEmail = document.getElementById('btn-alterar-email');
    //     btnAlterarEmail.addEventListener('click', function () {
    //         const novoEmail = document.getElementById('novo-email').value.trim();
    //         const confirmarEmail = document.getElementById('confirmar-email').value.trim();
    //         const $erro = document.getElementById('alterar-email-erro');
    //         if (!novoEmail || !confirmarEmail) { $erro.classList.remove('d-none'); $erro.querySelector('.retorno-mensagem-email').textContent = i18next.t('AlterarEmailValidacao'); return; }
    //         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //         if (!emailRegex.test(novoEmail)) { $erro.classList.remove('d-none'); $erro.querySelector('.retorno-mensagem-email').textContent = i18next.t('AlterarEmailFormatoInvalido'); return; }
    //         if (novoEmail !== confirmarEmail) { $erro.classList.remove('d-none'); $erro.querySelector('.retorno-mensagem-email').textContent = i18next.t('AlterarEmailConfirmacaoValidacao'); return; }
    //         $erro.classList.add('d-none');
    //         _callAlterarEmailSMS(novoEmail);
    //     });
    //     $container.classList.remove('d-none');
    // };

    // const _callAlterarEmailSMS = async (novoEmail) => {
    //     loadFullPage.mostrar();
    //     const token = document.getElementById('TokenAlterarEmail').value;
    //     const callbackSucesso = (resultado) => {
    //         loadFullPage.esconder();
    //         if (resultado.sucesso) { window.location.href = resultado.redirectUrl; }
    //         else { const $erro = document.getElementById('alterar-email-erro'); $erro.classList.remove('d-none'); $erro.querySelector('.retorno-mensagem-email').textContent = resultado.mensagem; }
    //     };
    //     const callbackErro = (resultado) => {
    //         loadFullPage.esconder();
    //         const $erro = document.getElementById('alterar-email-erro'); $erro.classList.remove('d-none');
    //         $erro.querySelector('.retorno-mensagem-email').textContent = resultado.mensagem || i18next.t('AlterarEmailErroGenerico');
    //     };
    //     const body = JSON.stringify({ Token: token, NovoEmail: novoEmail });
    //     await postFetch(`/api/${CULTURE_EMPREGARE}/candidato/alterar-email-sms`, body, callbackSucesso, callbackErro, callbackErro, false, false, { 'Content-Type': 'application/json' });
    // };

    const init = function () {
        inicializarInternacionalizacao();
        // var maskOptions = {
        //     mask: "000.000.000-00",
        // };
        // IMask($form.querySelector('#cpf'), maskOptions);

        const validar = new JustValidate($form, {
            errorFieldCssClass: "is-invalid"
        });
        validar
            // .addField("#paisID", [{ rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoPais') },])
            // .addField("#cpf", [{ rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoCpf') }])
            .addField("#emailCpf", [
                { rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmailCpf') },
                // {
                //     rule: "email",
                //     errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmailInvalido'),
                // },
            ]);

        $form.addEventListener('submit', function (e) {
            $form.querySelector('#row-erro').classList.add('d-none');
            validar.revalidate().then((isValid) => {
                if (isValid) {
                    _call();
                }
            });
            e.preventDefault();
        }, false);


        // $form.querySelector('#paisID').addEventListener('change', function () {
        //     var id = this.value;

        //     if (id == '') {
        //         document.getElementById('btn-esqueci-senha').classList.add('d-none');
        //         return;
        //     }
        //     document.getElementById('btn-esqueci-senha').classList.remove('d-none');
        //     if (id == 'BR') {
        //         document.getElementById('cpf-esqueci-senha').classList.remove('d-none');
        //         document.getElementById('email-esqueci-senha').classList.add('d-none');

        //         validar.removeField('#email');
        //         validar.addField("#cpf", [{ rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoCpf') }]);

        //     } else {
        //         document.getElementById('cpf-esqueci-senha').classList.add('d-none');
        //         document.getElementById('email-esqueci-senha').classList.remove('d-none');
        //         validar.removeField('#cpf');
        //         validar.addField("#email", [
        //             { rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmail') },
        //             {
        //                 rule: "email",
        //                 errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmailInvalido'),
        //             },
        //         ]);
        //     }
        // }, false);

        // const geoData = getGeoData();
        
        // if (geoData.existe) {           
        //     $form.querySelector('#paisID').value = geoData.data.pais;
        //     if ("createEvent" in document) {
        //         var evt = document.createEvent("HTMLEvents");
        //         evt.initEvent("change", false, true);
        //         $form.querySelector('#paisID').dispatchEvent(evt);
        //     }
        //     else
        //         $form.querySelector('#paisID').fireEvent("onchange");

        // }

        document.getElementById('btnAlterarSenhaEmail').addEventListener('click', function () {

            _callAlterarSenhaEmail();
        }, false);

        //document.getElementById('btnAlterarSenhaQuestionario').addEventListener('click', function () {

        //    _callAlterarSenhaQuestionario();
        //}, false);


    }
    return init();
}

esqueciSenha();